<ion-grid class="max-w-1336 content-box">
	<ion-row>
		<ion-col
			size="4"
			*ngIf="pagesService.getPermissionByName('company-epp-signups') | async"
		>
			<ion-card color="success" [routerLink]="['epp-signups']">
				<ion-card-header>
					<ion-card-title>epp-signups</ion-card-title>
				</ion-card-header>
			</ion-card>
		</ion-col>
		<!-- <ion-col class="box-8" [routerLink]="['update-info']">
			<ion-card color="success">
				<ion-card-header>
					<ion-card-title>update-info</ion-card-title>
				</ion-card-header>
			</ion-card>
		</ion-col> -->
		<ion-col
			class="box-8"
			size="4"
			[routerLink]="['manage-email']"
			*ngIf="pagesService.getPermissionByName('company-manage-email') | async"
		>
			<ion-card color="success">
				<ion-card-header>
					<ion-card-title>manage-email</ion-card-title>
				</ion-card-header>
			</ion-card>
		</ion-col>
		<ion-col
			size="4"
			[routerLink]="['b2b']"
			*ngIf="pagesService.getPermissionByName('company-b2b') | async"
		>
			<ion-card color="success">
				<ion-card-header>
					<ion-card-title>B2B</ion-card-title>
				</ion-card-header>
			</ion-card>
		</ion-col>
	</ion-row>
</ion-grid>
